import { SagaIterator } from 'redux-saga';
import { fork, put, take } from 'redux-saga/effects';
import config from '@/server/config';
import upload from '@/server/upload';

// 定义常量
export const types = {
    VIEWSANDUPLOAD_SHOW: 'user/imgs/viewsandupload/SHOW',
    VIEWSANDUPLOAD_HIDE: 'user/imgs/viewsandupload/HIDE',
    VIEWSANDUPLOAD_UPLOAD: 'user/imgs/viewsandupload/UPLOAD',
    VIEWSANDUPLOAD_SUCCESS: 'user/imgs/viewsandupload/SUCCESS'
}

let bindUploadAction: any;

// 定义action接口
export interface IViewsAndUploadAction {
    type: string;
    data?: {
        onUpload?(src: string): void;
        src: string;
    },
    files?: any;
    payload?: any;
}
// 定义状态接口
export interface IViewsAndUploadStoreState {
    src: string,
    visible: boolean;
}

// 隐藏操作
export const hideAction = () => {
    return {
        type: types.VIEWSANDUPLOAD_HIDE
    }
}
// 确认操作
export const uploadAction = (e: any) => {
    return {
        type: types.VIEWSANDUPLOAD_UPLOAD,
        files: e
    }
}

const initState = {
    src: '',
    visible: false
}

export default (state: IViewsAndUploadStoreState = initState, action: IViewsAndUploadAction): IViewsAndUploadStoreState => {
    switch(action.type) {
        case types.VIEWSANDUPLOAD_SUCCESS:
            if(bindUploadAction) {
                bindUploadAction(action.payload.data.obj);
            }
            return {
                ...state,
                src: config.API + 'image/download/crmAnnex?imgId=' + action.payload.data.obj,
            }
        case types.VIEWSANDUPLOAD_SHOW:
            // 绑定确认处理函数
            if(action.data && action.data.onUpload) {
                bindUploadAction = action.data.onUpload;
            } else {
                bindUploadAction = null;
            }
            return {
                src: action.data ? action.data.src : '',
                visible: true,
            }
        case types.VIEWSANDUPLOAD_HIDE:
            return {
                src: '',
                visible: false
            }
        default:
            return state;
    }
}

// 定义saga
/**
 * 本页面使用，获取数据异步操作处理函数
 * @param action 组件提供action
 */
function* uploadAsync( action: IViewsAndUploadAction ): any {
    const r = yield upload(action.files, true);
    yield put({ type: types.VIEWSANDUPLOAD_SUCCESS, payload: {
        data: r
    }});
}

// 利用takeEvery检测未来可能会发生的行为，并且执行相应的操作
export function* watchUploadAsync(): SagaIterator {
    while(true) {
        const action = yield take(types.VIEWSANDUPLOAD_UPLOAD);
        yield fork(uploadAsync, action);
    }
}